/* Ways to stay tabs */
import 'slick-carousel';

export function ways_to_stay_tabs() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--ways-to-stay-tabs' ).length <= 0 ) {
				return;
			}

			$( '.block--ways-to-stay-tabs .gallery' ).each( ( i, e ) => {
				const slider = $( e );

				slider.slick( {
					arrows: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					rows: 0,
					dots: true,
				} );
			} );

			$( '.block--ways-to-stay-tabs .nav-link' ).each( ( i, e ) => {
				$( e ).on( 'show.bs.tab', ( ev ) => {
					$( $( e ).data( 'bs-target' ) )
						.find( '.gallery' )
						.each( ( i2, e2 ) => {
							$( e2 )
								.slick( 'unslick' )
								.slick( {
									arrows: true,
									infinite: false,
									slidesToShow: 1,
									slidesToScroll: 1,
									rows: 0,
									dots: true,
								} );
					} );
				} );
			} );

			$( '.block--ways-to-stay-tabs .nav-link[data-bs-toggle="tab"]' ).on( 'shown.bs.tab', function ( event ) {
				// Get the target tab's data-bs-target attribute
				const target = $( event.target ).data( 'bs-target' );

				// Update the URL without reloading the page
				if ( history.pushState ) {
					history.pushState( null, null, target );
				} else {
					window.location.hash = target;
				}
			});

			const activateTabFromHash = () => {
				const hash = window.location.hash;
				if ( hash ) {
					// Load the correct tab based on the hash
					$( '.block--ways-to-stay-tabs .nav-link.active' ).removeClass( 'active' );
					$( '.block--ways-to-stay-tabs .tab-pane.active.show' ).removeClass( 'active show' );
					$( '.block--ways-to-stay-tabs .nav-link[data-bs-target="' + hash + '"]' ).addClass( 'active' );
					$( '.block--ways-to-stay-tabs ' + hash ).addClass( 'active show' );

					// Add scroll with offset after tab activation
					const targetElement = $( hash );
					const target_position = parseInt( $( targetElement ).offset().top - window.COVE.navbar_total_height );

					if ( targetElement.length ) {
						$( 'html, body' ).animate( {
							scrollTop: target_position
						} );
					}
				}
			};

			activateTabFromHash();

			// Handle browser back/forward button navigation
			window.addEventListener( 'popstate', () => {
				activateTabFromHash();
			} );
		}

		init();

	} )( window.jQuery );
}
